export const WorkoutsDetail = {
  template: `
    <div class="workouts-detail bg-white">
      <workout>
        <workout-nav-left>
          <button-back></button-back>
        </workout-nav-left>
      </workout>
    </div>`,
};



// WEBPACK FOOTER //
// ./src/containers/Workouts/Detail.js